import { useState } from 'react';
import { OutlineTable, PageContent, PageToolbar, TableHeader, Title } from '@recargas-dominicanas/core/components';
import { PageContainer } from '@recargas-dominicanas/core/components';
import { ProductItem } from './product-item/product-item.component';
import { useProductStore } from '../../store/productStore';
import { OptionButton } from '@recargas-dominicanas/core/components';
import { AddProductModal } from './add-product-modal/add-product-modal.component';
import { style } from './products.module.css';

export function Products() {

  const { products } = useProductStore();
  const [openAddModal, setOpenAddModal] = useState(false);

  return (
    <PageContainer className={style.container}>
      <PageToolbar className={style.toolbar}>
        <Title style={style.title} title='Productos'/>
        <OptionButton
          icon='library_add' 
          title='Agregar producto'
          onClick={() => setOpenAddModal(true)}/>
      </PageToolbar>
      <PageContent className={style.content}>
        <OutlineTable style={style.table}>
          <TableHeader style={style.tableHeader}>
            <span>Logo</span>
            <span>Nombre</span>
            <span>Clave</span>
            <span>Tipo</span>
            <span>Categoria</span>
            <span>Beneficio</span>
            <span>Estado</span>
            <span></span>
          </TableHeader>
          <tbody>
            {
              products?.map(product => 
                <ProductItem
                  key={product.id} 
                  product={product}/>
              )
            }
          </tbody>
        </OutlineTable>
        <AddProductModal
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}/>
      </PageContent>
    </PageContainer>
  );
}
